import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-2xl font-bold text-[#1a1a1a]" style={{ fontFamily: "'Outfit', sans-serif" }}>
      {title}
    </h2>
    <div className="space-y-3 text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      {children}
    </div>
  </section>
);

const AccessibilityStatementPage = () => {
  return (
    <div className="page-fade-in">
      <section className="bg-[#EEF8F2] text-[#1a1a1a] border-b border-[#42D78A]/20 py-20 md:py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-[#42D78A] text-sm tracking-[0.2em] uppercase mb-4 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            614 Shop Local
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Accessibility Statement
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Last updated June 14, 2026
          </p>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto space-y-10">
          <div className="rounded-2xl border border-gray-100 bg-gray-50 p-6">
            <p className="text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              614 Shop Local is committed to making our website accessible and usable for as many people as possible, including people who use assistive technologies.
            </p>
          </div>

          <Section title="Our Commitment">
            <p>
              We aim to provide a site experience that is clear, navigable, and inclusive. As this is a new version of our site, we are continuing to review and improve accessibility across our pages, forms, directories, account areas, and event listings.
            </p>
          </Section>

          <Section title="Accessibility Goals">
            <p>
              We work toward supporting common accessibility practices, including readable text, keyboard-accessible controls, meaningful page structure, descriptive labels, sufficient color contrast, responsive layouts, and compatibility with screen readers where possible.
            </p>
          </Section>

          <Section title="Ongoing Improvements">
            <p>
              Accessibility is an ongoing effort. We may update layouts, labels, colors, form behavior, image text alternatives, and navigation patterns as we identify opportunities to improve the experience.
            </p>
          </Section>

          <Section title="Third-Party Content">
            <p>
              Some parts of the site may link to third-party websites or services, such as social media pages, Discord, email tools, payment providers, or business and market websites. We cannot control the accessibility of third-party content, but we encourage partners and listed organizations to provide accessible experiences.
            </p>
          </Section>

          <Section title="Need Help or Found an Issue?">
            <p>
              If you experience an accessibility barrier on 614 Shop Local, please contact us and tell us what page or feature caused the issue, what assistive technology or browser you were using if applicable, and how we can help.
            </p>
            <p>
              You can email us at{" "}
              <a href="mailto:hello@614shoplocal.com" className="font-bold text-[#1a1a1a] hover:text-[#42D78A]">
                hello@614shoplocal.com
              </a>{" "}
              or reach us through the <Link to="/contact" className="font-bold text-[#1a1a1a] hover:text-[#42D78A]">contact page</Link>.
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
};

export default AccessibilityStatementPage;
